export default __webpack_public_path__ + "img/nkossa.a2906539.jpg";